'use client';

import Image from 'next/image';
import { useState } from 'react';

export const BannerImage = ({ imageUrl }: { imageUrl: string }) => {
  const [isError, setIsError] = useState(false);

  if (isError) return null;

  return (
    <Image
      src={imageUrl}
      alt=""
      width={30}
      height={30}
      data-testid="top-banner-image"
      className="m-[1px]"
      onError={() => setIsError(true)}
    />
  );
};
